"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var configure_exports = {};
__export(configure_exports, {
  configureAnalyticsProviders: () => configureAnalyticsProviders
});
module.exports = __toCommonJS(configure_exports);
var import_analytics = require("@hcengineering/analytics");
var import_analyticsCollector = require("./analyticsCollector");
var import_posthog = require("./posthog");
var import_sentry = require("./sentry");
__reExport(configure_exports, require("./analyticsCollector"), module.exports);
__reExport(configure_exports, require("./posthog"), module.exports);
__reExport(configure_exports, require("./sentry"), module.exports);
__reExport(configure_exports, require("./utils"), module.exports);
__reExport(configure_exports, require("./types"), module.exports);
function configureAnalyticsProviders(config) {
  const providers = [
    new import_analyticsCollector.AnalyticsCollectorProvider(),
    new import_sentry.SentryAnalyticProvider(),
    new import_posthog.PosthogAnalyticProvider()
  ];
  for (const provider of providers) {
    import_analytics.Analytics.init(provider, config);
  }
}
__name(configureAnalyticsProviders, "configureAnalyticsProviders");
//# sourceMappingURL=configure.js.map
